<div class="background">
  <div class="title-container">
    <h2>
      Homepage Langues Vivantes
    </h2>
  </div>
  <div class="main-container-wrap">
    <div class="main-container">
      <div *ngFor="let link of linkItems" class="link-container">
        <a [href]="link.url" target="_blank" class="link">
          <img *ngIf="link.faviconUrl" [src]="link.faviconUrl" class="site-icon">
          <p *ngIf="!link.faviconUrl" class="link-name">{{link.name}}</p>
        </a>
      </div>
    </div>
  </div>
</div>